(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("create-react-class"), require("uu5g04"), require("uu5g04-bricks"), require("uu5g04-forms"), require("module"));
	else if(typeof define === 'function' && define.amd)
		define("UuContentkitg01", ["react", "prop-types", "create-react-class", "uu5g04", "uu5g04-bricks", "uu5g04-forms", "module"], factory);
	else if(typeof exports === 'object')
		exports["UuContentkitg01"] = factory(require("react"), require("prop-types"), require("create-react-class"), require("uu5g04"), require("uu5g04-bricks"), require("uu5g04-forms"), require("module"));
	else
		root["UuContentkitg01"] = factory(root["React"], root["PropTypes"], root["createReactClass"], root["UU5"], root["UU5.Bricks"], root["UU5.Forms"], root["undefined"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_10__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition